import React from 'react';
import { domainConfig } from 'src/helpers/domainConfig';

import CashplaneTerms from './cashplane';
import HubtalkTerms from './hubtalk';
import LaserprofitTerms from './laserprofit';

class Terms extends React.Component {
  render() {
    let { newHome, title } = domainConfig;
    if (title === 'LaserProfit') return <LaserprofitTerms />;
    return newHome && title !== 'LaserProfit' ? <HubtalkTerms /> : <CashplaneTerms />;
  }
}
export default Terms;
